// extracted by mini-css-extract-plugin
var _1 = "tjs-tabs__btn--tab tjs-_buttons__btn";
var _2 = "tjs-tabs__btn--tab tjs-_buttons__btn";
var _3 = "tjs-tabs__panel-content tjs-_base__clearfix";
var _4 = "tjs-tabs__panel-content tjs-_base__clearfix";
var _5 = "tjs-tabs__tab-left-col";
var _6 = "tjs-tabs__tab-list tjs-_base__list-reset tjs-_base__clearfix";
var _7 = "tjs-tabs__tab-list__item";
var _8 = "tjs-tabs__tab-panel";
var _9 = "tjs-tabs__tab-left-col";
var _a = "tjs-tabs__tab-list tjs-_base__list-reset tjs-_base__clearfix";
var _b = "tjs-tabs__tab-list__item";
var _c = "tjs-tabs__tab-panel";
var _d = "tjs-tabs__tabs";
export { _1 as "btn--tab", _2 as "btnTab", _3 as "panel-content", _4 as "panelContent", _5 as "tab-left-col", _6 as "tab-list", _7 as "tab-list__item", _8 as "tab-panel", _9 as "tabLeftCol", _a as "tabList", _b as "tabListItem", _c as "tabPanel", _d as "tabs" }
export default { "btn--tab": _1, "btnTab": _2, "panel-content": _3, "panelContent": _4, "tab-left-col": _5, "tab-list": _6, "tab-list__item": _7, "tab-panel": _8, "tabLeftCol": _9, "tabList": _a, "tabListItem": _b, "tabPanel": _c, "tabs": _d }
